import { render, staticRenderFns } from "./FranchiseLeaderboard.vue?vue&type=template&id=6cf07d34&"
import script from "./FranchiseLeaderboard.vue?vue&type=script&lang=js&"
export * from "./FranchiseLeaderboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports